import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { ResultWithApiMessages } from "../extract-graphql-error-message"

// Keyed by query identity + message, not one shared flag: asset-view and drilldown beta mount
// concurrently, and a shared flag would let one's portfolio switch re-arm or suppress the other's.
// Never cleared on unmount — revisiting the same portfolio before a reload must not re-toast.
const _shownWarningKeys = new Set<string>()

export function __resetForTesting(): void {
  if (process.env.NODE_ENV !== "production") {
    _shownWarningKeys.clear()
  }
}

export function useFieldScopedErrorWarning(resetKey: string) {
  const dispatch = useDispatch()

  return useCallback((result: ResultWithApiMessages, message: string | undefined) => {
    const toleratedErrors = result?.apiMessages?.errors
    if (!message || !Array.isArray(toleratedErrors) || toleratedErrors.length === 0) {
      return
    }
    // Message is part of the key so a second opt-in gatherer's toast can't be swallowed by beta's.
    const warningKey = [resetKey, message].join("\n")
    if (_shownWarningKeys.has(warningKey)) {
      return
    }
    _shownWarningKeys.add(warningKey)
    dispatch(NotificationCreators.add("warning", null, message))
  }, [dispatch, resetKey])
}
